import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import * as fromDeals from './deals.reducer';
import * as fromDealDetails from './deal-details.reducer';
import * as fromRecruitingDashboard from './recruiting-dashboard.reducers';
import * as fromDirectOfferImportMargins from './direct-offer-import-margin.reducer';
import * as fromCandidateDetails from './candidate-details.reducer';
import { RecruitingDashboardState } from '../state/recruiting-dashboard.state';

export const recruitingFeatureKey = 'recruiting-store';

export interface RecruitingRootStoreState {
    dashboard: RecruitingDashboardState;
    deals: fromDeals.DealsState;
    dealDetails: fromDealDetails.DealDetailsState;
    directOfferMargins: fromDirectOfferImportMargins.DirectOfferImportMarginsState;
    candidateDetails: fromCandidateDetails.CandidateDetailsState;
}

export const reducers: ActionReducerMap<RecruitingRootStoreState> = {
    dashboard: fromRecruitingDashboard.recruitingDashboardReducer,
    deals: fromDeals.dealsReducer,
    dealDetails: fromDealDetails.dealDetailsReducer,
    directOfferMargins: fromDirectOfferImportMargins.directOfferImportMarginsReducer,
    candidateDetails: fromCandidateDetails.candidateDetailsReducer
};

export const recruitingFeature = createFeatureSelector<RecruitingRootStoreState>(recruitingFeatureKey);
